<div class="m0030">
    <div *ngFor="let menuitem of menuItems">
        <px-a00030-primary-button
            [target]="menuitem.target"
            [link]="menuitem.link"
            [text]="menuitem.name"
        ></px-a00030-primary-button>
    </div>
</div>
